module.exports = __webpack_public_path__ + "static/media/power-10.ae2232cd.svg";